import styled from 'styled-components';
import { Col } from 'antd';

export const ItemLabelHeader = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #748aa1;
`;

export const ItemLabelContent = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  color: #31394d;
  padding-top: 5px;
`;

export const AlertScoreWrapper = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  color: #31394d;
  display: flex;
  align-items: center;
  padding-top: 3px;

  .ant-progress-line {
    width: auto;
    margin-right: 5px;
  }

  .ant-progress-inner {
    width: 80px;

    .ant-progress-bg {
      height: 12px !important;
    }
  }

  p {
    margin: 2px 0 0;
    font-weight: 300;
    font-size: 9px;
    line-height: 16px;

    b {
      font-weight: bold;
      font-size: 12px;
    }
  }
`;

export const ItemLabelWraper = styled(Col)`
  font-weight: 400;
  font-size: 12px;
  color: #9dc5e9;
`;

export const ItemValueWrapper = styled(Col)`
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  word-break: break-all;
`;
